<mat-form-field class="craft-tags-field" appearance="fill" [ariaAutoComplete]="false">
  <mat-chip-grid #chipList [disabled]="disabled">
    <mat-chip *ngFor="let id of ids" (removed)="remove(id)" class="tag">
      <craft-icon *ngIf="!disabled" matChipRemove class="svg-icon text-size-9" name="general--close-sm"></craft-icon>
      <span class="ellipsis" [title]="tagsMap[id].title || ''">{{ tagsMap[id].title || '' }}</span>
    </mat-chip>
    <input
      #tagInput=""
      class="tag-input"
      [placeholder]="placeholder"
      maxlength="255"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="false"
      (matChipInputTokenEnd)="add($event, tagInput)"
      (keyup)="inputChanged$.next(tagInput.value)"
      (click)="$event.stopPropagation()"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayName" (optionSelected)="selectAutocompleteTag($event, tagInput)">
    <mat-option *ngFor="let tag of autocompleteTags$ | async | slice: 0 : 20; trackBy: identifyTags" [value]="tag" [title]="tag.title">
      {{ tag.title }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
